module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0030.jpg?v=954bd0db";